import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import { cn } from '../../../../utils/utils';
import RowView from '../RowView';
import Text from '../../../../components/Text';

const Chips = ({
  value,
  onChange,
  options,
  label,
  required = true,
  keyValue = 'name',
  isMulti = false,
}) => {
  const { TextWeight } = dynamicfunction();
  const handleSelect = (id) => {
    if (!isMulti) {
      onChange(id);
      return;
    }

    const currentValue = Array.isArray(value) ? value : [];

    if (currentValue.includes(id)) {
      onChange(currentValue.filter((v) => v !== id));
    } else {
      onChange([...currentValue, id]);
    }
  };

  const isSelected = (id) => {
    if (!isMulti) return value === id;
    return Array.isArray(value) && value.includes(id);
  };
  return (
    <>
      <Text
        text={label && label}
        size={fontSizes.h14}
        className={`mb-1`}
        isRequired={required}
        isTruncate={false}
      />
      <RowView className='flex-wrap gap-2 mt-1'>
        {options && options?.length > 0 ? (
          options?.map((item, index) => (
            //
            <div
              key={index}
              // onClick={() => onChange(item?.id)}
              onClick={() => handleSelect(item?.id)}
              style={{ cursor: 'pointer' }}
            >
              {/*  value === item?.id */}
              <div
                className={cn(
                  isSelected(item?.id) ? 'bg-primary/10' : 'bg-grey/50',
                  'px-3 py-2 rounded-md transition-all duration-200'
                )}
              >
                <Text
                  text={item?.[keyValue]}
                  color={
                    isSelected(item?.id) ? 'text-primary' : 'text-silver-text'
                  }
                  weight={TextWeight.medium}
                  size={fontSizes.h14}
                  isTruncate={false}
                />
              </div>
            </div>
          ))
        ) : (
          <Text text='No Data Available' />
        )}
      </RowView>
    </>
  );
};

export default Chips;
